import type { CreateTourAppealFormShort } from 'shared/api/tours/buy-ticket'
import type { RawTourFlight } from 'shared/api/tours/flights'
import type { Hotel, Tour } from 'shared/api/tours/search'
import { preparePhoneNumberForRequest } from 'shared/lib/prepare-phone-number'

export interface ClientDataFormValues {
  firstName: string
  lastName: string
  phoneNumber: { code: string; phone: string }
}

export interface GetClientDataAppealPayloadParams {
  formValues: ClientDataFormValues
  flight: RawTourFlight | null
  hotel: Hotel | null
  room: Tour | null
  hotelSearchSessionId: string | null | undefined
  departureCityId?: string
}

export const getClientDataAppealPayload = (
  params: GetClientDataAppealPayloadParams,
): CreateTourAppealFormShort | null => {
  const {
    formValues,
    flight,
    hotel,
    room,
    hotelSearchSessionId,
    departureCityId,
  } = params

  if (!hotel || !room || !hotelSearchSessionId || !departureCityId) {
    return null
  }

  const { firstName, lastName, phoneNumber } = formValues

  return {
    personal_data: {
      first_name: firstName,
      last_name: lastName,
      phoneNumber: preparePhoneNumberForRequest(phoneNumber) || '',
    },
    ...(flight && { flights: flight }),
    hotel_id: hotel.id,
    hotel_search_session_id: hotelSearchSessionId,
    tour_id: room.id,
    price: Number(room.price),
    departure_city_id: departureCityId,
    operator: room.operator_key,
  }
}
